import Services from '../../../../services'

class AsetMasterApi {
  update(data) {
    return Services.put('/asetmaster/nonaktif', data)
  }
}

export default new AsetMasterApi()
